import Vue from 'vue';
import RoReadMore from './RoReadMore';

Vue.component('RoReadMore', RoReadMore);

export default RoReadMore;



// WEBPACK FOOTER //
// ./scripts/ro-read-more/index.js